<template>
    <div class="top">
        <div class="checklist-top"
             v-bind:class="{ 'checklist-top-active': mazlicekJmeno.valid, 'checklist-top-noactive': !mazlicekJmeno.valid }">
            <div class="checklist-jmeno" v-if="mazlicekJmeno.valid">{{ mazlicekJmeno.value }}</div>
            <div class="checklist-rasa" v-if="mazlicekRasa.typ === 'app_rasa'">{{ mazlicekRasa.autocomplete.keyword
                }}
            </div>
            <div class="checklist-rasa" v-else-if="mazlicekRasa.typ === 'app_velikost' && velikost && velikost.title !== null">
                {{ velikost.title }}
            </div>
            <div class="checklist-foto" v-if="mazlicekFoto.valid">
                <img :src="mazlicekFoto.value? mazlicekFoto.value : mazlicekFoto.icnValue"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {apiSilex} from '../api'

    export default {
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                rasa: null,
                velikost: null
            }
        },
        computed: {
            mazlicekJmeno() {
                return this.mazlicek.jmeno
            },
            mazlicekRasa() {
                return this.mazlicek.rasa
            },
            mazlicekFoto() {
                return this.mazlicek.fotografie
            }
        },
        methods: {
            loadSize() {
                if (this.velikost === null && this.mazlicek.rasa.velikost) {
                    apiSilex.get('/velikost?id=' + this.mazlicek.rasa.velikost).then(response => {
                        this.velikost = response.data[0]
                    })
                }
            }
        },
        mounted: function () {
            this.loadSize()
        },
        watch: {
            'mazlicek.rasa': {
                deep: true,
                handler: function (val) {
                    this.rasa = val
                    this.loadSize()
                }
            },
            'mazlicek.petLoaded': {
                deep: true,
                handler: function (val) {
                    if (this.mazlicek.petLoaded.value) this.loadSize()
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// RightContentHeader.vue?874ca550